(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flur-bf-gift-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  function isGift(item) { return item.properties?._flur_bf_gift === 'clear-iced'; }

  // What the customer pays toward the gift: the cart total minus gift cards and the gift itself.
  function paidTotal(cart) {
    return (cart.items || []).reduce((sum, item) => {
      if (item.requires_shipping === false || isGift(item)) return sum - Number(item.final_line_price || 0);
      return sum;
    }, Number(cart.total_price || 0));
  }

  function planGift(cart, config) {
    const gifts = (cart.items || []).filter(isGift);
    const have = gifts.reduce((sum, item) => sum + item.quantity, 0);
    const want = config.enabled && config.available && paidTotal(cart) >= config.at ? 1 : 0;
    const updates = {};
    let keep = want;
    for (const item of gifts) {
      const q = Math.min(item.quantity, keep);
      if (q !== item.quantity) updates[item.key] = q;
      keep -= q;
    }
    return { updates, missing: Math.max(0, want - have) };
  }

  function boot() {
    if (window.FLURBFGift) return;
    const node = document.querySelector('[data-bf-gift-config]');
    if (!node) return;
    let config;
    try { config = JSON.parse(node.textContent); } catch { return; }
    if (!config.variantId) return;
    if (!config.autoAdd) { window.FLURBFGift = { config }; return; }
    const root = (config.root || '/').replace(/\/?$/, '/');
    let pending = null;
    let dirty = false;

    async function request(path, body) {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        cache: 'no-store',
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error('Black Friday gift cart request failed');
      return response.json();
    }

    function announce(cart, sections) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
        resource: cart,
        sourceId: 'flur-bf-gift',
        data: { source: 'flur-bf-gift', itemCount: cart.item_count, isIncremental: false, sections }
      } }));
    }

    function sync() {
      dirty = true;
      if (pending) return pending;
      pending = (async () => {
        let changed = false;
        let renderedSections;
        for (let attempt = 0; attempt < 6; attempt++) {
          dirty = false;
          const cart = await request('cart.js');
          const plan = planGift(cart, config);
          const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(element => element.dataset.sectionId))].slice(0, 5);
          const sectionRequest = sectionIds.length ? { sections: sectionIds, sections_url: window.location.pathname } : {};
          if (Object.keys(plan.updates).length) {
            const response = await request('cart/update.js', { updates: plan.updates, ...sectionRequest });
            renderedSections = response.sections;
            changed = true;
            continue;
          }
          if (plan.missing) {
            const response = await request('cart/add.js', { ...sectionRequest, items: [{
              id: config.variantId, quantity: 1, properties: { _flur_bf_gift: 'clear-iced' }
            }] });
            renderedSections = response.sections;
            changed = true;
            continue;
          }
          if (dirty) continue;
          if (changed) {
            const fresh = await request('cart.js');
            announce(fresh, renderedSections);
          }
          return cart;
        }
        throw new Error('Black Friday gift cart did not settle');
      })().finally(() => { pending = null; });
      return pending;
    }

    document.addEventListener('cart:update', event => {
      if (event.detail?.data?.source === 'flur-bf-gift') return;
      sync().catch(() => {});
    });
    window.addEventListener('pageshow', () => sync().catch(() => {}));
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) sync().catch(() => {});
    });
    window.FLURBFGift = { sync, config };
    sync().catch(() => {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flur-family-gift-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  function planGift(cart, config) {
    const items = cart.items || [];
    const families = items.filter(item => String(item.product_id) === String(config.familyId))
      .reduce((sum, item) => sum + item.quantity, 0);
    const trays = items.filter(item => String(item.variant_id || item.id) === String(config.trayVariantId));
    const managed = trays.filter(item => item.properties?._flur_family_gift === 'family-set');
    const ordinary = trays.filter(item => item.properties?._flur_family_gift !== 'family-set')
      .reduce((sum, item) => sum + item.quantity, 0);
    const target = config.enabled ? Math.max(0, families - ordinary) : 0;
    const managedQuantity = managed.reduce((sum, item) => sum + item.quantity, 0);
    const updates = {};
    let excess = managedQuantity - target;
    for (const item of managed) {
      if (excess <= 0) break;
      const removed = Math.min(item.quantity, excess);
      updates[item.key] = item.quantity - removed;
      excess -= removed;
    }
    return { families, trays, managed, updates, missing: Math.max(0, target - managedQuantity) };
  }

  function giftConfirmed(cart, config) {
    const plan = planGift(cart, config);
    if (!config.enabled) return plan.managed.length === 0;
    if (!plan.families) return plan.managed.length === 0;
    let free = 0;
    let managedPaid = false;
    for (const item of plan.trays) {
      const savings = (item.line_level_discount_allocations || item.discount_allocations || [])
        .filter(allocation => allocation.discount_application?.title === config.discountTitle)
        .reduce((sum, allocation) => sum + Number(allocation.amount || 0), 0);
      const price = Number(item.original_price ?? item.price);
      if (price > 0) free += Math.min(item.quantity, Math.floor(savings / price));
      if (item.properties?._flur_family_gift === 'family-set' && Number(item.final_line_price) > 0) managedPaid = true;
    }
    return !managedPaid && free >= plan.families;
  }

  function boot() {
    if (window.FLURFamilyGift) return;
    const node = document.querySelector('[data-family-gift-config]');
    if (!node) return;
    let config;
    try { config = JSON.parse(node.textContent); } catch { return; }
    if (!config.familyId || !config.trayVariantId) return;
    const root = (config.root || '/').replace(/\/?$/, '/');
    let pending = null;
    let dirty = false;
    let checkoutBusy = false;
    let bypass = false;
    let noticeText = '';

    function notice(message) {
      noticeText = message;
      document.querySelectorAll('[data-family-gift-error]').forEach(element => {
        element.textContent = message;
        element.hidden = !message;
      });
    }

    async function request(path, body) {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        cache: 'no-store',
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error('Family gift cart request failed');
      return response.json();
    }

    function announce(cart, sections) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
        resource: cart,
        sourceId: 'flur-family-gift',
        data: { source: 'flur-family-gift', itemCount: cart.item_count, isIncremental: false, sections }
      } }));
    }

    function sync() {
      dirty = true;
      if (pending) return pending;
      pending = (async () => {
        let changed = false;
        let renderedSections;
        for (let attempt = 0; attempt < 8; attempt++) {
          dirty = false;
          const cart = await request('cart.js');
          const plan = planGift(cart, config);
          const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(element => element.dataset.sectionId))].slice(0, 5);
          const sectionRequest = sectionIds.length ? { sections: sectionIds, sections_url: window.location.pathname } : {};
          if (Object.keys(plan.updates).length) {
            const response = await request('cart/update.js', { updates: plan.updates, ...sectionRequest });
            renderedSections = response.sections;
            changed = true;
            continue;
          }
          if (plan.missing && config.available) {
            const response = await request('cart/add.js', { ...sectionRequest, items: [{
              id: config.trayVariantId, quantity: plan.missing,
              properties: { _flur_family_gift: 'family-set' }
            }] });
            renderedSections = response.sections;
            changed = true;
            continue;
          }
          if (dirty) continue;
          if (changed) announce(cart, renderedSections);
          const confirmed = giftConfirmed(cart, config);
          notice(confirmed || !config.enabled || config.available ? '' : config.unavailable);
          return { cart, confirmed };
        }
        throw new Error('Family gift cart did not settle');
      })().catch(error => {
        notice('');
        throw error;
      }).finally(() => { pending = null; });
      return pending;
    }

    async function waitForCart() {
      if (!document.querySelector('.cart-items-disabled')) return;
      await new Promise((resolve, reject) => {
        const observer = new MutationObserver(() => {
          if (!document.querySelector('.cart-items-disabled')) {
            observer.disconnect();
            clearTimeout(timeout);
            resolve();
          }
        });
        const timeout = setTimeout(() => { observer.disconnect(); reject(new Error('Cart is busy')); }, 10000);
        observer.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['class'] });
      });
    }

    async function checkout(button) {
      if (checkoutBusy) return;
      checkoutBusy = true;
      button.setAttribute('aria-busy', 'true');
      const inDrawer = !!button.closest('cart-drawer-component');
      try {
        await waitForCart();
        const result = await sync();
        // Never hold the customer at the button: the tray is discounted by the set offer now, not free.
        const selector = inDrawer ? 'cart-drawer-component button[name="checkout"]' : 'main button[name="checkout"]';
        const current = document.querySelector(selector) || button;
        if (!current.form || !current.isConnected) throw new Error('Checkout form unavailable');
        bypass = true;
        try { current.form.requestSubmit(current); } finally { bypass = false; }
      } catch {
        notice('');
      } finally {
        checkoutBusy = false;
        button.removeAttribute('aria-busy');
      }
    }

    document.addEventListener('click', event => {
      const button = event.target.closest?.('button[name="checkout"]');
      if (!button || bypass) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      checkout(button);
    }, true);

    document.addEventListener('submit', event => {
      if (bypass || event.submitter?.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      checkout(event.submitter);
    }, true);

    document.addEventListener('cart:update', event => {
      if (event.detail?.data?.source === 'flur-family-gift') return;
      sync().catch(() => {});
    });
    window.addEventListener('pageshow', () => sync().catch(() => {}));
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) sync().catch(() => {});
    });
    new MutationObserver(() => {
      if (noticeText) document.querySelectorAll('[data-family-gift-error]').forEach(element => {
        if (element.textContent !== noticeText) element.textContent = noticeText;
        if (element.hidden) element.hidden = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
    window.FLURFamilyGift = { sync };
    sync().catch(() => {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
